import React from "react";

const H1TipTap = ({ editor, height, width }) => {
  return (
    <svg
      className="cursor-pointer  mr-15 pt-5"
      onClick={(e) => {
        e.preventDefault();
        editor.chain().focus().toggleHeading({ level: 1 }).run();
      }}
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M12 12.1875V0H9.28896V4.78729H3.31708V0H0.625V12.1875H3.31708V7.07131H9.28896V12.1875H12Z"
          fill={
            editor.isActive("heading", { level: 1 }) ? "#4652b7" : "#807e7e"
          }
        />
        <path
          d="M16.875 12.1875V5.6875H15.6684L13.625 7.74372L14.4132 8.57206L15.4933 7.47086V12.1875H16.875Z"
          fill={
            editor.isActive("heading", { level: 1 }) ? "#4652b7" : "#807e7e"
          }
        />
      </g>
    </svg>
  );
};

export default H1TipTap;
